import axios from 'axios';
import { URL_APPEND, API_APPEND, ORIGINPATH } from '@general/constants';

let options = {
  url: '',
  method: '',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  }
};

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) axios.defaults.headers.common['X-CSRFToken'] = token.content;

let ax = (url, method, formData, notapi) => {
  // isajax.update(o => ({ ...o, loading: true }));

  return axios({
    ...options,
    url: notapi ? (URL_APPEND + url) : (API_APPEND + url),
    method,
    data: formData
  }).then(result => {
    return result;
  });
}

let ax2 = (url, method) => axios({
  ...options,
  url: API_APPEND + url,
  method
}).then(result => {
  return result;
});

let ax3 = (url, method, formData) => {
  // isajax.update(o => ({ ...o, loading: true }));

  return axios({
    ...options,
    url: API_APPEND + url,
    method,
    headers: { 'content-type': 'multipart/form-data' },
    data: formData
  }).then(result => {
    return result;
  });
}


export const postData = (url, formData, notapi) => ax(url, 'post', formData, notapi);

export const postFormData = (url, formData) => ax3(url, 'post', formData);

export const getData = (url) => ax2(url, 'get');

export const deleteData = (url) => ax2(url, 'delete');

export const updateData = (url, formData) => ax(url, 'put', formData);

export const updateFormData = (url, formData) => ax3(url, 'post', formData);

